import { EncryptionKeys } from "controllers/EncryptionController"

export const addKeyToLocalStorageObject = (
  type:
    | EncryptionKeys.conversationEncryptionKeys
    | EncryptionKeys.projectEncryptionKeys
    | EncryptionKeys.buildAdditionalInfoEncryptionKeys,
  additional: Object
) => {
  const keyObject = JSON.parse(localStorage.getItem(type) || "{}")
  const result = {
    ...keyObject,
    ...additional,
  }
  localStorage.setItem(type, JSON.stringify(result))
}
